import {Component, OnInit} from '@angular/core';
import {SystemUserService} from '../../../services/system-user.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';


@Component({
  standalone: false,
    selector: 'app-system-user-add',
    templateUrl: './system-user-add.component.html',
})
export class SystemUserAddComponent implements OnInit {

    systemUserId = 0;
    systemUser: any = {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        mobile_number: '',
        id_role: 30,
    };

    validationTriggered = false;

    constructor(
        private systemUserService: SystemUserService,
        private toaster: ToastrService,
        private router: Router,
    ) {

    }

    ngOnInit(): any {

    }

    addSystemUser() {
        this.validationTriggered = true;

        if (!this.isSystemUserFilled(this.systemUser)) {
            this.toaster.error('Please fill in all required field.');
            return
        }
        // this.spinner.show();
        const { confirm_password, ...userData } = this.systemUser;
        this.systemUserService.addSystemUser(userData).subscribe((result : any) => {
            // this.spinner.hide();    
            this.validationTriggered = false;
            this.toaster.success('New System User Added');
            this.router.navigate(['/system-user/list']);
        },
        (error : any) => {
            // this.spinner.hide();
            this.toaster.error(error.error[0]);
            console.log(error);
        });
    }

    isSystemUserFilled(systemUser : any): boolean {
        for (const su in systemUser) {
            if (su != 'id_role') {
                if (systemUser[su] == '') {
                    return false;
                }
            } 
        }
        if (systemUser.password != systemUser.confirm_password) return false;
        return true;
    }

    isValidEmail(email: string): boolean {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }
}